import { render, staticRenderFns } from "./addNewModel.vue?vue&type=template&id=121960ac"
import script from "./addNewModel.vue?vue&type=script&lang=js"
export * from "./addNewModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports